const STORAGE_KEY = "ace_dashboard_token";
const CALLOUT_PREFIX = "ace_dashboard_callout_";

export const getDashboardToken = () => sessionStorage.getItem(STORAGE_KEY);

export const setDashboardToken = (token) => {
  sessionStorage.setItem(STORAGE_KEY, token);
};

export const clearDashboardToken = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const hasDashboardCalloutBeenUsed = (calloutId) =>
  localStorage.getItem(`${CALLOUT_PREFIX}${calloutId}`) === "1";

export const markDashboardCalloutUsed = (calloutId) => {
  localStorage.setItem(`${CALLOUT_PREFIX}${calloutId}`, "1");
};
